import { zipObject } from 'lodash-es';

import { OPERATORS } from './filtering';
import { CLIENT, CLIENT_ADMIN } from './roles';

export const ORG_ACTIVE_STATUS = 'ACTIVE';
export const ORG_CANCELLED_STATUS = 'CANCELLED';
export const ORG_INACTIVE_STATUS = 'INACTIVE';

export const ORG_TYPES = {
  consumer: 'consumer',
  partner: 'partner',
  supplier: 'supplier',
};

export const ORG_ID_PREFIX = 'Or';
export const ORG_DATA_PRODUCT_LOGO_URL_SUFFIX = '/assets/logo?idType=id';

export const CREATE_ORG_NAME_ROUTE_NAME = 'orgs-create-type-name';
export const CREATE_ORG_DETAILS_ROUTE_NAME = 'orgs-create-type-details';
export const CREATE_ORG_USERS_ROUTE_NAME = 'orgs-create-id-users';

export const ORG_DATA_PRODUCT_ROUTES = {
  datasets: 'orgs-id-data-products-dataProductId-datasets',
  settings: 'orgs-id-data-products-dataProductId-settings',
  subscribers: 'orgs-id-data-products-dataProductId-subscribers',
  subscription: 'orgs-id-data-products-dataProductId-subscription',
};

export const ORG_DATA_PRODUCTS_FILTERS = {
  withDeleted: {
    operator: OPERATORS.is,
    value: false,
  },
};

export const ORG_CREATE_CONSUMER_STEPS = [
  {
    label: 'Describe Your Org',
    to: {
      name: CREATE_ORG_NAME_ROUTE_NAME,
      params: { type: ORG_TYPES.consumer },
    },
  },
  {
    label: 'Add Org Details',
    to: {
      name: CREATE_ORG_DETAILS_ROUTE_NAME,
      params: { type: ORG_TYPES.consumer },
    },
  },
  {
    label: 'Add Users',
    to: {
      name: CREATE_ORG_USERS_ROUTE_NAME,
    },
  },
];

export const ORG_CREATE_SUPPLIER_STEPS = [
  {
    label: 'Describe Your Org',
    to: {
      name: CREATE_ORG_NAME_ROUTE_NAME,
      params: { type: ORG_TYPES.supplier },
    },
  },
  {
    label: 'Add Org Details',
    to: {
      name: CREATE_ORG_DETAILS_ROUTE_NAME,
      params: { type: ORG_TYPES.supplier },
    },
  },
  {
    label: 'Add Users',
    to: {
      name: CREATE_ORG_USERS_ROUTE_NAME,
    },
  },
];

export const ORG_LEGAL_MULTISELECT_OPTIONS = [
  { label: 'SNA', value: 'SNA' },
  { label: 'MSA', value: 'MSA' },
  { label: 'Supplier Legal Paperwork', value: 'Supplier Legal Paperwork' },
  { label: 'Other', value: 'Other' },
];

export const ORG_ROUTES = {
  destinations: 'orgs-id-destinations',
  home: 'orgs-id',
  settings: 'orgs-id-settings',
};

export const ORG_STATUS_DISPLAY_MAP = {
  [ORG_ACTIVE_STATUS]: 'Active',
  [ORG_INACTIVE_STATUS]: 'Deactivated',
};

export const ORG_STATUS_ICON_COLOR_MAP = {
  [ORG_ACTIVE_STATUS]: 'text-green-500',
  [ORG_INACTIVE_STATUS]: 'text-gray-400',
};

export const ORG_STATUS_ICON_MAP = {
  [ORG_ACTIVE_STATUS]: 'checkbox-circle-fill',
  [ORG_INACTIVE_STATUS]: 'indeterminate-circle-fill',
};

export const ORG_SUPPLIER_TYPE_MULTISELECT_OPTIONS = [
  { label: 'Tier 1', value: 'Tier 1' },
  { label: 'Tier 2', value: 'Tier 2' },
  { label: 'Prospect', value: 'Prospect' },
  { label: 'Client Proprietary', value: 'Client Proprietary' },
  { label: 'Public', value: 'Public' },
];

export const ORGS_TABLE_FILTERS = {
  createdAt: {
    operator: '',
    value: '',
  },

  status: {
    operator: OPERATORS.in,
    value: [],
  },

  type: {
    operator: OPERATORS.in,
    value: [],
  },
};

export const ORG_USER_STATUS_COLOR_MAP = {
  unverified: 'purple',
  verified: 'green',
};

export const EMPTY_USER = {
  email: '',
  name: '',
  role: CLIENT,
};

export const INITIAL_USERS = [
  {
    email: '',
    name: '',
    role: CLIENT_ADMIN,
  },
  {
    email: '',
    name: '',
    role: CLIENT,
  },
];

export const EMPTY_ORG = {
  attr: {
    address: '',
    city: '',
    country: '',
    state: '',
    zip: '',
  },
  code: '',
  description: '',
  name: '',
  website: '',
};

export const EMPTY_ORG_ADDRESS = {
  attr: {
    address: '',
    city: '',
    country: '',
    state: '',
    zip: '',
  },
  website: '',
};

export const COVER = 'coverImage';
export const LOGO = 'logo';

export const ORG_IMAGE_TYPES = {
  cover: COVER,
  logo: LOGO,
};

export const ORG_ROUTE_NAME = 'orgs-id';
export const ORG_ID_ENTITLEMENTS_SELECT_ROUTE = 'orgs-id-index-entitlements';

export const CUSIP = 'cusip';
export const SEDOL = 'sedol';
export const OTHER_CONSUMER_DATA_LICENSE = 'other';
export const CONSUMER_DATA_LICENSES = zipObject(
  [CUSIP, SEDOL, OTHER_CONSUMER_DATA_LICENSE],
  [CUSIP, SEDOL, OTHER_CONSUMER_DATA_LICENSE],
);
